/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-contract
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from "zod";

/**
 * Retrieves contract details
 */
export const getContractPathContractIdMin = 0;

export const getContractParams = zod.object({
  contract_id: zod
    .number()
    .min(getContractPathContractIdMin)
    .describe("The contract ID"),
});

export const getContractHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getContractResponseAccountIdMin = 0;
export const getContractResponseContractIdMin = 0;

export const getContractResponse = zod.object({
  account_id: zod
    .number()
    .min(getContractResponseAccountIdMin)
    .optional()
    .describe("The contract's account ID"),
  contract_id: zod
    .number()
    .min(getContractResponseContractIdMin)
    .optional()
    .describe("Abacus contract ID"),
  contract_name: zod.string().optional().describe("Abacus contract name"),
  contract_type: zod
    .enum(["distribution", "legacy_distribution", "neighbouring_rights"])
    .optional()
    .describe("The contract type"),
  created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  created_by: zod.string().optional(),
  execution_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  general_note: zod
    .string()
    .optional()
    .describe("General notes related to the contract"),
  initial_start_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  is_excluded_from_accounting_run: zod
    .boolean()
    .optional()
    .describe(
      "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
    ),
  last_modified: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  last_modified_by: zod.string().optional(),
  oa_contract_id: zod.number().optional().describe("ID of OA contract"),
  reference_sap_profit_center_id: zod
    .number()
    .optional()
    .describe("ID of SAP-related metadata"),
  reference_signing_entity_id: zod
    .number()
    .optional()
    .describe("ID of related reference_signing_entity"),
  sap_created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  summary_note: zod
    .string()
    .optional()
    .describe("Summary notes related to the contract"),
  term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

/**
 * Update contract details for a specified contract
 */
export const updateContractPathContractIdMin = 0;

export const updateContractParams = zod.object({
  contract_id: zod
    .number()
    .min(updateContractPathContractIdMin)
    .describe("The contract ID"),
});

export const updateContractHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const updateContractBody = zod.object({
  contract_name: zod.string().optional().describe("Abacus contract name"),
  general_note: zod
    .string()
    .optional()
    .describe("General notes related to the contract"),
  execution_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  initial_start_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  is_excluded_from_accounting_run: zod
    .boolean()
    .optional()
    .describe(
      "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
    ),
  reference_sap_profit_center_id: zod
    .number()
    .optional()
    .describe("ID of contract's SAP-related metadata"),
  reference_signing_entity_id: zod
    .number()
    .optional()
    .describe("ID of related reference_signing_entity"),
  sap_created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  summary_note: zod
    .string()
    .optional()
    .describe("Summary notes related to the contract"),
  term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

export const updateContractResponseAccountIdMin = 0;
export const updateContractResponseContractIdMin = 0;

export const updateContractResponse = zod.object({
  account_id: zod
    .number()
    .min(updateContractResponseAccountIdMin)
    .optional()
    .describe("The contract's account ID"),
  contract_id: zod
    .number()
    .min(updateContractResponseContractIdMin)
    .optional()
    .describe("Abacus contract ID"),
  contract_name: zod.string().optional().describe("Abacus contract name"),
  contract_type: zod
    .enum(["distribution", "legacy_distribution", "neighbouring_rights"])
    .optional()
    .describe("The contract type"),
  created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  created_by: zod.string().optional(),
  execution_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  general_note: zod
    .string()
    .optional()
    .describe("General notes related to the contract"),
  initial_start_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  is_excluded_from_accounting_run: zod
    .boolean()
    .optional()
    .describe(
      "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
    ),
  last_modified: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  last_modified_by: zod.string().optional(),
  oa_contract_id: zod.number().optional().describe("ID of OA contract"),
  reference_sap_profit_center_id: zod
    .number()
    .optional()
    .describe("ID of SAP-related metadata"),
  reference_signing_entity_id: zod
    .number()
    .optional()
    .describe("ID of related reference_signing_entity"),
  sap_created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  summary_note: zod
    .string()
    .optional()
    .describe("Summary notes related to the contract"),
  term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

/**
 * Get the contract lifecycle associated to the specified contract
 */
export const getContractLifecyclePathContractIdMin = 0;

export const getContractLifecycleParams = zod.object({
  contract_id: zod
    .number()
    .min(getContractLifecyclePathContractIdMin)
    .describe("The contract ID"),
});

export const getContractLifecycleResponseContractLifecycleIdMin = 0;
export const getContractLifecycleResponseContractIdMin = 0;
export const getContractLifecycleResponseContractLifecycleScheduleIdMin = 0;

export const getContractLifecycleResponse = zod.object({
  contract_lifecycle_id: zod
    .number()
    .min(getContractLifecycleResponseContractLifecycleIdMin)
    .optional()
    .describe("ID of the contract_lifecycle"),
  contract_id: zod
    .number()
    .min(getContractLifecycleResponseContractIdMin)
    .optional()
    .describe("Abacus contract ID"),
  contract_lifecycle_schedule_id: zod
    .number()
    .min(getContractLifecycleResponseContractLifecycleScheduleIdMin)
    .optional()
    .describe("Foreign key to contract_lifecycle_schedule table"),
  lifecycle_status: zod
    .enum([
      "active",
      "in_collection_period",
      "inactive",
      "init",
      "terminated",
      "to_be_terminated",
    ])
    .optional()
    .describe("Contract lifecycle status"),
  lifecycle_term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  lifecycle_term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  renewal_effective: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  termination_notice_deadline: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  termination_notice_received: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  termination_effective: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  collection_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  collection_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

/**
 * Terminate a contract
 */
export const terminateContractPathContractIdMin = 0;

export const terminateContractParams = zod.object({
  contract_id: zod
    .number()
    .min(terminateContractPathContractIdMin)
    .describe("The contract ID"),
});

export const terminateContractHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const terminateContractBody = zod.object({
  termination_effective: zod
    .string()
    .date()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  termination_notice_received: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

export const terminateContractResponseAccountIdMin = 0;
export const terminateContractResponseContractIdMin = 0;

export const terminateContractResponse = zod.object({
  account_id: zod
    .number()
    .min(terminateContractResponseAccountIdMin)
    .optional()
    .describe("The contract's account ID"),
  contract_id: zod
    .number()
    .min(terminateContractResponseContractIdMin)
    .optional()
    .describe("Abacus contract ID"),
  contract_name: zod.string().optional().describe("Abacus contract name"),
  contract_type: zod
    .enum(["distribution", "legacy_distribution", "neighbouring_rights"])
    .optional()
    .describe("The contract type"),
  created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  created_by: zod.string().optional(),
  execution_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  general_note: zod
    .string()
    .optional()
    .describe("General notes related to the contract"),
  initial_start_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  is_excluded_from_accounting_run: zod
    .boolean()
    .optional()
    .describe(
      "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
    ),
  last_modified: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  last_modified_by: zod.string().optional(),
  oa_contract_id: zod.number().optional().describe("ID of OA contract"),
  reference_sap_profit_center_id: zod
    .number()
    .optional()
    .describe("ID of SAP-related metadata"),
  reference_signing_entity_id: zod
    .number()
    .optional()
    .describe("ID of related reference_signing_entity"),
  sap_created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  summary_note: zod
    .string()
    .optional()
    .describe("Summary notes related to the contract"),
  term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

/**
 * Reactivate a contract
 */
export const reactivateContractPathContractIdMin = 0;

export const reactivateContractParams = zod.object({
  contract_id: zod
    .number()
    .min(reactivateContractPathContractIdMin)
    .describe("The contract ID"),
});

export const reactivateContractHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const reactivateContractResponseAccountIdMin = 0;
export const reactivateContractResponseContractIdMin = 0;

export const reactivateContractResponse = zod.object({
  account_id: zod
    .number()
    .min(reactivateContractResponseAccountIdMin)
    .optional()
    .describe("The contract's account ID"),
  contract_id: zod
    .number()
    .min(reactivateContractResponseContractIdMin)
    .optional()
    .describe("Abacus contract ID"),
  contract_name: zod.string().optional().describe("Abacus contract name"),
  contract_type: zod
    .enum(["distribution", "legacy_distribution", "neighbouring_rights"])
    .optional()
    .describe("The contract type"),
  created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  created_by: zod.string().optional(),
  execution_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  general_note: zod
    .string()
    .optional()
    .describe("General notes related to the contract"),
  initial_start_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  is_excluded_from_accounting_run: zod
    .boolean()
    .optional()
    .describe(
      "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
    ),
  last_modified: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  last_modified_by: zod.string().optional(),
  oa_contract_id: zod.number().optional().describe("ID of OA contract"),
  reference_sap_profit_center_id: zod
    .number()
    .optional()
    .describe("ID of SAP-related metadata"),
  reference_signing_entity_id: zod
    .number()
    .optional()
    .describe("ID of related reference_signing_entity"),
  sap_created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  summary_note: zod
    .string()
    .optional()
    .describe("Summary notes related to the contract"),
  term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});

/**
 * Get a list of contracts by contract_id
 */
export const getContractsBodyMin = 0;

export const getContractsBodyItem = zod
  .number()
  .min(getContractsBodyMin)
  .describe("Abacus contract ID");
export const getContractsBody = zod.array(getContractsBodyItem);

export const getContractsResponseAccountIdMin = 0;
export const getContractsResponseContractIdMin = 0;

export const getContractsResponseItem = zod.object({
  account_id: zod
    .number()
    .min(getContractsResponseAccountIdMin)
    .optional()
    .describe("The contract's account ID"),
  contract_id: zod
    .number()
    .min(getContractsResponseContractIdMin)
    .optional()
    .describe("Abacus contract ID"),
  contract_name: zod.string().optional().describe("Abacus contract name"),
  contract_type: zod
    .enum(["distribution", "legacy_distribution", "neighbouring_rights"])
    .optional()
    .describe("The contract type"),
  created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  created_by: zod.string().optional(),
  execution_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  general_note: zod
    .string()
    .optional()
    .describe("General notes related to the contract"),
  initial_start_date: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  is_excluded_from_accounting_run: zod
    .boolean()
    .optional()
    .describe(
      "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
    ),
  last_modified: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  last_modified_by: zod.string().optional(),
  oa_contract_id: zod.number().optional().describe("ID of OA contract"),
  reference_sap_profit_center_id: zod
    .number()
    .optional()
    .describe("ID of SAP-related metadata"),
  reference_signing_entity_id: zod
    .number()
    .optional()
    .describe("ID of related reference_signing_entity"),
  sap_created_at: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  summary_note: zod
    .string()
    .optional()
    .describe("Summary notes related to the contract"),
  term_end: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
  term_start: zod
    .string()
    .date()
    .optional()
    .describe("A datetime string formatted as YYYY-MM-DD"),
});
export const getContractsResponse = zod.array(getContractsResponseItem);

/**
 * Get a list of contracts by contract_id
 */
export const dataloadContractsBodyMin = 0;

export const dataloadContractsBodyItem = zod
  .number()
  .min(dataloadContractsBodyMin)
  .describe("Abacus contract ID");
export const dataloadContractsBody = zod.array(dataloadContractsBodyItem);

export const dataloadContractsResponseDataAccountIdMin = 0;
export const dataloadContractsResponseDataContractIdMin = 0;

export const dataloadContractsResponseItem = zod
  .object({
    data: zod
      .object({
        account_id: zod
          .number()
          .min(dataloadContractsResponseDataAccountIdMin)
          .optional()
          .describe("The contract's account ID"),
        contract_id: zod
          .number()
          .min(dataloadContractsResponseDataContractIdMin)
          .optional()
          .describe("Abacus contract ID"),
        contract_name: zod.string().optional().describe("Abacus contract name"),
        contract_type: zod
          .enum(["distribution", "legacy_distribution", "neighbouring_rights"])
          .optional()
          .describe("The contract type"),
        created_at: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
        created_by: zod.string().optional(),
        execution_date: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
        general_note: zod
          .string()
          .optional()
          .describe("General notes related to the contract"),
        initial_start_date: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
        is_excluded_from_accounting_run: zod
          .boolean()
          .optional()
          .describe(
            "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
          ),
        last_modified: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
        last_modified_by: zod.string().optional(),
        oa_contract_id: zod.number().optional().describe("ID of OA contract"),
        reference_sap_profit_center_id: zod
          .number()
          .optional()
          .describe("ID of SAP-related metadata"),
        reference_signing_entity_id: zod
          .number()
          .optional()
          .describe("ID of related reference_signing_entity"),
        sap_created_at: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
        summary_note: zod
          .string()
          .optional()
          .describe("Summary notes related to the contract"),
        term_end: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
        term_start: zod
          .string()
          .date()
          .optional()
          .describe("A datetime string formatted as YYYY-MM-DD"),
      })
      .optional(),
  })
  .describe("{data: AbacusContract | null }");
export const dataloadContractsResponse = zod.array(
  dataloadContractsResponseItem,
);

/**
 * Check the health of the application.
 */
export const getHealthHeader = zod.object({
  "Correlation-Id": zod.string().optional().describe("Correlation ID"),
});

export const getHealthResponse = zod.object({
  status: zod.enum(["ok"]),
});
/**
 * Generated by @abacus/api-client-generator
 * Do not edit manually.
 */
const z = zod;

const AccountId = z.number();
const ContractId = z.number();
const ContractName = z.string();
const ContractType = z.enum([
  "distribution",
  "legacy_distribution",
  "neighbouring_rights",
]);
const Date = z.string();
const PartialContract = z
  .object({
    account_id: AccountId.int().gte(0).describe("The contract's account ID"),
    contract_id: ContractId.int().gte(0).describe("The contract ID"),
    contract_name: ContractName.describe("Abacus contract name"),
    contract_type: ContractType.describe("The contract type"),
    created_at: Date.describe("A datetime string formatted as YYYY-MM-DD"),
    created_by: z.string(),
    execution_date: Date.describe("A datetime string formatted as YYYY-MM-DD"),
    general_note: z.string().describe("General notes related to the contract"),
    initial_start_date: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    is_excluded_from_accounting_run: z
      .boolean()
      .describe(
        "whether a contract should be used during the accounting run calculation(by default all contracts are included)",
      ),
    last_modified: Date.describe("A datetime string formatted as YYYY-MM-DD"),
    last_modified_by: z.string(),
    oa_contract_id: z.number().int().describe("ID of OA contract"),
    reference_sap_profit_center_id: z
      .number()
      .int()
      .describe("ID of SAP-related metadata"),
    reference_signing_entity_id: z
      .number()
      .int()
      .describe("ID of related reference_signing_entity"),
    sap_created_at: Date.describe("A datetime string formatted as YYYY-MM-DD"),
    summary_note: z.string().describe("Summary notes related to the contract"),
    term_end: Date.describe("A datetime string formatted as YYYY-MM-DD"),
    term_start: Date.describe("A datetime string formatted as YYYY-MM-DD"),
  })
  .partial()
  .passthrough();
const Contract = PartialContract;
const ContractLifecycleId = z.number();
const ContractLifecycleScheduleId = z.number();
const ContractLifecycleStatus = z.enum([
  "active",
  "in_collection_period",
  "inactive",
  "init",
  "terminated",
  "to_be_terminated",
]);
const ContractLifecycle = z
  .object({
    contract_lifecycle_id: ContractLifecycleId.gte(0).describe(
      "ID of the contract_lifecycle",
    ),
    contract_id: ContractId.int().gte(0).describe("The contract ID"),
    contract_lifecycle_schedule_id: ContractLifecycleScheduleId.gte(0).describe(
      "Foreign key to contract_lifecycle_schedule table",
    ),
    lifecycle_status: ContractLifecycleStatus.describe(
      "Contract lifecycle status",
    ),
    lifecycle_term_start: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    lifecycle_term_end: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    renewal_effective: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    termination_notice_deadline: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    termination_notice_received: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    termination_effective: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    collection_start: Date.describe(
      "A datetime string formatted as YYYY-MM-DD",
    ),
    collection_end: Date.describe("A datetime string formatted as YYYY-MM-DD"),
  })
  .partial()
  .passthrough();
const ContractTerminationEffective = Date;
const ContractTerminationNoticeReceived = Date;
const Health = z.object({ status: z.literal("ok") }).passthrough();
const DateTime = z.string();

export const accountId = AccountId;
export const contractId = ContractId;
export const contractName = ContractName;
export const contractType = ContractType;
export const date = Date;
export const partialContract = PartialContract;
export const contract = Contract;
export const contractLifecycleId = ContractLifecycleId;
export const contractLifecycleScheduleId = ContractLifecycleScheduleId;
export const contractLifecycleStatus = ContractLifecycleStatus;
export const contractLifecycle = ContractLifecycle;
export const contractTerminationEffective = ContractTerminationEffective;
export const contractTerminationNoticeReceived =
  ContractTerminationNoticeReceived;
export const health = Health;
export const dateTime = DateTime;
